<template>
  <div class="contain">
    <div class="swiper-container home-swiper-container">
      <div class="swiper-wrapper">
        <div v-for="(item, index) in data" :key="index" class="swiper-slide home-banner" :style="{'background-image': 'url(' + item + ')'}"></div>
      </div>
      <!-- Add Pagination -->
      <div class="swiper-pagination home-swiper-pagination"></div>
    </div>
    <img :src="$img( 'sb.png' )" class="sb" />
  </div>
</template>

<script>
export default {
  props: ['data'],
  watch: {
    data (val) {
      if (val) {
        setTimeout(() => {
          new Swiper('.home-swiper-container', {
            autoplay: 5000,
            loop: true,
            pagination: '.home-swiper-pagination'
          })
        }, 300)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.contain, .home-swiper-container {
  height: 100%;
  .home-banner {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
}

.contain {
  position: relative;
}

.home-swiper-pagination {
  bottom: 104px;
  /deep/ .swiper-pagination-bullet-active {
    background: #c39047;
  }
}

.sb {
  position: absolute;
  bottom: 52px;
  left: calc(50% - 13px);
  z-index: 2;
}
</style>